import { computed } from 'vue';
import { getColorClass, getRatingInfo } from '@/utils/agilityRatings';
import type { ColorType } from '@/utils/agilityRatings';

export function useAgilityRating(score: number) {
  const ratingInfo = computed(() => getRatingInfo(score));
  
  const getBorderClass = computed(() => getColorClass(score, 'border'));
  const getBackgroundClass = computed(() => getColorClass(score, 'bg'));
  const getTextClass = computed(() => getColorClass(score, 'text'));
  
  const getClass = (type: ColorType) => getColorClass(score, type);
  
  return {
    ratingInfo,
    getBorderClass,
    getBackgroundClass,
    getTextClass,
    getClass
  };
} 